"use strict";

// =======================
// STICKY MENU
// =======================
const header = document.getElementById("main-header");
let lastScrollTop = 0;
let isFixed = false;

window.addEventListener("scroll", function () {
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

  if (scrollTop > 50 && !isFixed) {
    header.classList.add(
      "top-8",
      "z-50",
      "radius-nav",
      "translate-y-4",
      "p-nav",
      "translate-y-0",
      "shadow-md"
    );
    header.classList.remove("px-4", "py-8", "lg:py-16");
    isFixed = true;
  } else if (scrollTop <= 50 && isFixed) {
    header.classList.remove(
      "top-8",
      "z-50",
      "radius-nav",
      "translate-y-4",
      "p-nav",
      "translate-y-0",
      "shadow-md"
    );
    header.classList.add("px-4", "py-8", "lg:py-16");
    isFixed = false;
  }

  if (scrollTop > lastScrollTop && scrollTop > 50) {
    header.classList.add("-translate-y-full");
  } else {
    header.classList.remove("-translate-y-full");
  }

  lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
});

// =======================
// MOBILE MENU
// =======================
const menuToggle = document.getElementById("menu-toggle");
const mobileMenu = document.getElementById("mobile-menu");

if (menuToggle && mobileMenu) {
  menuToggle.addEventListener("click", () => {
    mobileMenu.classList.toggle("hidden");
  });
}

// =======================
// SLIDER
// =======================
const totalSlides = 3;
let currentSlide = 1;

function resetAnimations() {
  document.getElementById("hero-1-left")?.classList.remove("animate-in-left");
  document.getElementById("hero-1-right")?.classList.remove("animate-in-right");
  document.getElementById("hero-2-left")?.classList.remove("animate-in-left");
  document.getElementById("hero-3-left")?.classList.remove("animate-in-left");
  document.getElementById("hero-3-right")?.classList.remove("animate-in-right");
}

function showSlide(slide) {
  for (let i = 1; i <= totalSlides; i++) {
    const s = document.getElementById(`slide-${i}`);
    if (s) {
      if (i === slide) {
        s.classList.add("opacity-100", "z-10");
        s.classList.remove("opacity-0", "z-0");
      } else {
        s.classList.add("opacity-0", "z-0");
        s.classList.remove("opacity-100", "z-10");
      }
    }
  }

  resetAnimations();

  // Trigger animation for the current slide
  setTimeout(() => {
    if (slide === 1) {
      document.getElementById("hero-1-left")?.classList.add("animate-in-left");
      document
        .getElementById("hero-1-right")
        ?.classList.add("animate-in-right");
    } else if (slide === 2) {
      document.getElementById("hero-2-left")?.classList.add("animate-in-left");
    } else if (slide === 3) {
      document.getElementById("hero-3-left")?.classList.add("animate-in-left");
      document
        .getElementById("hero-3-right")
        ?.classList.add("animate-in-right");
    }
  }, 100);
}

// Auto play every 5 seconds
setInterval(() => {
  currentSlide = currentSlide < totalSlides ? currentSlide + 1 : 1;
  showSlide(currentSlide);
}, 5000);

// Initial run
if (document.getElementById("slide-1")) {
  showSlide(currentSlide);
}

// =======================
// FAQS
// =======================
document.addEventListener("DOMContentLoaded", () => {
  const wrapper = document.getElementById("faq-wrapper");
  
  if (wrapper) {
    wrapper.addEventListener("click", (e) => {
      const item = e.target.closest(".accordion-item");
      if (!item) return;

      const isOpen = item.classList.contains("open");

      wrapper
        .querySelectorAll(".accordion-item")
        .forEach((el) => el.classList.remove("open"));

      if (!isOpen) item.classList.add("open");
    });
  }
});

// =======================
// MODAL PLAY VIDEO
// =======================
document.addEventListener("DOMContentLoaded", () => {
  const openBtn = document.getElementById("openVideoBtn");
  const closeBtn = document.getElementById("closeVideoBtn");
  const modal = document.getElementById("videoModal");
  const iframe = document.getElementById("youtubeIframe");

  // Get YouTube URL from WordPress customizer or use default
  const youtubeURL = window.x_laundry_theme?.youtube_url || "https://www.youtube.com/embed/1tNB16aQVR4";

  if (openBtn && modal && iframe) {
    openBtn.addEventListener("click", () => {
      iframe.src = youtubeURL + "?autoplay=1";
      modal.classList.remove("hidden");
    });
  }

  if (closeBtn && modal && iframe) {
    closeBtn.addEventListener("click", () => {
      iframe.src = "";
      modal.classList.add("hidden");
    });
  }

  if (modal && iframe) {
    modal.addEventListener("click", (e) => {
      if (e.target === modal) {
        iframe.src = "";
        modal.classList.add("hidden");
      }
    });
  }
});

// =======================
// SMOOTH SCROLLING FOR ANCHOR LINKS
// =======================
document.addEventListener("DOMContentLoaded", () => {
  const links = document.querySelectorAll('a[href^="#"]');
  
  links.forEach(link => {
    link.addEventListener("click", (e) => {
      const href = link.getAttribute("href");
      
      // Skip if it's just "#" or if it's external
      if (href === "#" || href.startsWith("http")) return;
      
      const target = document.querySelector(href);
      
      if (target) {
        e.preventDefault();
        
        const headerHeight = document.getElementById("main-header")?.offsetHeight || 0;
        const targetPosition = target.offsetTop - headerHeight - 20;
        
        window.scrollTo({
          top: targetPosition,
          behavior: "smooth"
        });
      }
    });
  });
});

// =======================
// INTERSECTION OBSERVER FOR ANIMATIONS
// =======================
document.addEventListener("DOMContentLoaded", () => {
  const observerOptions = {
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px"
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add("animate-in");
      }
    });
  }, observerOptions);

  // Observe elements that should animate in
  const animateElements = document.querySelectorAll(".box, .container > section");
  animateElements.forEach(el => observer.observe(el));
});

// =======================
// WORDPRESS AJAX SUPPORT (if needed for future features)
// =======================
if (window.x_laundry_ajax) {
  // Example function for AJAX requests
  function makeAjaxRequest(action, data = {}) {
    const formData = new FormData();
    formData.append('action', action);
    formData.append('nonce', window.x_laundry_ajax.nonce);
    
    Object.keys(data).forEach(key => {
      formData.append(key, data[key]);
    });

    return fetch(window.x_laundry_ajax.ajax_url, {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .catch(error => console.error('AJAX Error:', error));
  }

  // Export for use in other scripts if needed
  window.x_laundry_theme = window.x_laundry_theme || {};
  window.x_laundry_theme.ajax = makeAjaxRequest;
}

// =======================
// ACCESSIBILITY IMPROVEMENTS
// =======================
document.addEventListener("DOMContentLoaded", () => {
  // Add keyboard navigation for mobile menu
  const menuToggle = document.getElementById("menu-toggle");
  
  if (menuToggle) {
    menuToggle.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        menuToggle.click();
      }
    });
  }

  // Add keyboard navigation for FAQ items
  const faqButtons = document.querySelectorAll(".accordion-item button");
  
  faqButtons.forEach(button => {
    button.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        button.click();
      }
    });
  });

  // Add keyboard navigation for video modal
  const openVideoBtn = document.getElementById("openVideoBtn");
  
  if (openVideoBtn) {
    openVideoBtn.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        openVideoBtn.click();
      }
    });
  }

  // Trap focus in modal when open
  const modal = document.getElementById("videoModal");
  const closeBtn = document.getElementById("closeVideoBtn");
  
  if (modal && closeBtn) {
    modal.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        closeBtn.click();
      }
    });
  }
});